module.exports = __webpack_public_path__ + "static/media/sectur03.beeb1aee.png";